export default __webpack_public_path__ + "static/media/img-4840.b5db6c3d.jpeg";